import User from "@/models/User";
import { Module } from "vuex";
import HttpClient from "../services/HttpClient";
import HttpClientFactory from "../services/HttpClientFactory";

interface AuthModuleState {
  user: User | null;
}

export const authModule: Module<AuthModuleState, any> = {
  namespaced: true as true,
  state: () => ({
    user: null,
  }),
  mutations: {
    SET_USER(state, user: User) {
      state.user = user;
    },
  },
  actions: {
    async setUser(context, user: User) {
      context.commit("SET_USER", user);
    },
    async loadUser(context) {
      const httpClient: HttpClient = HttpClientFactory.getInstance();

      const { data } = await httpClient.get(
        process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/user"
      );
      
      context.dispatch("setUser", data);
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
};
